import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import DesktopLayout from "../components/DesktopLayout/Layout";
import MobileLayout from "../components/MobileLayout/Layout";
import WebsocketManager from "../components/WebsocketManager/WebsocketManager";
import LoginPage from "../pages/Login/LoginPage";
import DesktopMain from "../components/DesktopMain/DesktopMain";
import BlockedPage from "../pages/BlockedPage";
import UnknownUserPage from "../pages/UnknownUserPage";
import ErrorPage from "../pages/ErrorPage";
import HomePage from "../pages/HomePage";
import MobileCursos from "../pages/MobileCursos";
import MobileCalendario from "../pages/MobileCalendario";
import { ToastContainer } from "react-toastify";
import Campus from "../pages/Campus";
import SeleccionCarrera from "../pages/SeleccionCarrera";
import { LoginProvider } from "../contexts/LoginContext";

const commonRoutes = [
  { path: "/login", element: <LoginPage /> },
  { path: "/bloqueo", element: <BlockedPage /> },
  { path: "/usuario", element: <UnknownUserPage /> },
  { path: "/error", element: <ErrorPage /> },
  { path: "/campus", element: <Campus /> },
  { path: "/carrera", element: <SeleccionCarrera /> },
  { path: "*", element: <Navigate to="/" /> },
];

const desktopRoutes = [{ path: "/", element: <DesktopMain /> }];

const mobileRoutes = [
  { path: "/", element: <HomePage /> },
  { path: "/mis-cursos", element: <MobileCursos /> },
];

interface AppRouterProps {
  lg: boolean;
  sessionExpired: boolean;
  mostrarHorarios: boolean;
}

const AppRouter: React.FC<AppRouterProps> = ({ lg, sessionExpired, mostrarHorarios }) => {
  const Layout = lg ? DesktopLayout : MobileLayout;
  const routes = [
    ...commonRoutes,
    ...(lg
      ? desktopRoutes
      : [...mobileRoutes, ...(mostrarHorarios ? [{ path: "/calendario", element: <MobileCalendario /> }] : [])]),
  ];

  return (
    <BrowserRouter>
      <LoginProvider>
        <Layout sessionExpired={sessionExpired}>
          <WebsocketManager />
          <Routes>
            {routes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Routes>
          <ToastContainer />
        </Layout>
      </LoginProvider>
    </BrowserRouter>
  );
};

export default AppRouter;
